import { useState, useEffect } from "react";
import CloseIcon from "@mui/icons-material/Close";
const userName = localStorage.getItem("name");
const userRole = localStorage.getItem("role");
export default function AddFeedbackModal({
  open,
  onClose,
  onSubmit,
  loading,
  editingCommentId,
  feedback,
  setFeedback,
  tone,
  setTone,
}) {
  //   const [feedback, setFeedback] = useState("");
  useEffect(() => {
    if (!open) {
      setFeedback("");
    }
  }, [open]);
  if (!open) return null;
  const ROLE_MAP = {
    "-1": "Super Admin",
    0: "Csm",
    1: "Business Development",
    2: "Management Trainee",
    3: "Purchase",
    4: "Operations Manager",
    5: "IP Manager",
    6: "Store Onboarding Executive",
    7: "Designer Manager",
  };
  const tones = [
    {
      label: "Positive",
      className: "border-green-200 bg-green-50 text-green-700",
    },
    {
      label: "Neutral",
      className: "border-slate-200 bg-slate-50 text-slate-700",
    },
    {
      label: "Needs Improvement",
      className: "border-pink-200 bg-pink-50 text-pink-700",
    },
    {
      label: "Recommend Blacklisting",
      className: "border-red-200 bg-red-50 text-red-700",
    },
  ];
  const handleSubmit = () => {
    onSubmit(feedback);
  };

  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/40 backdrop-blur-sm">
      <div className="w-full max-w-xl overflow-hidden rounded-xl bg-white shadow-2xl">
        {/* Header */}
        <div className="flex items-center justify-between border-b px-6 py-4">
          <h2 className="text-xl font-semibold text-[#163D8F]">
            {editingCommentId ? "Edit Feedback" : "Add Performance Feedback"}
          </h2>

          <button
            onClick={onClose}
            className="rounded-md p-1 hover:bg-slate-100"
          >
            <CloseIcon />
          </button>
        </div>

        {/* Body */}
        <div className="p-6">
          {/* User */}
          <div className="rounded-lg bg-slate-100 p-3">
            <div className="flex items-center gap-3">
              <div className="flex h-10 w-10 items-center justify-center rounded-lg bg-[#163D8F] text-sm font-semibold text-white">
                {userName?.charAt(0)?.toUpperCase()}
              </div>

              <div>
                <h3 className="font-medium text-slate-800">
                  {userName || "Unknown User"}
                </h3>

                <p className="text-xs text-slate-500">
                  {ROLE_MAP[userRole] || "Internal Feedback"}
                </p>
              </div>
            </div>
          </div>

          {/* Feedback Tone */}
          <div className="mt-6">
            <label className="mb-3 block text-xs font-semibold uppercase tracking-wide text-slate-500">
              Feedback Tone
            </label>

            <div className="grid grid-cols-2 gap-3 sm:grid-cols-4">
              {tones.map((item) => (
                <button
                  key={item.label}
                  onClick={() => setTone(item.label)}
                  className={`rounded-lg border p-3 text-xs font-medium transition-all ${
                    tone === item.label ? "ring-2 ring-[#163D8F]" : ""
                  } ${item.className}`}
                >
                  {item.label}
                </button>
              ))}
            </div>
          </div>

          {/* Feedback */}
          <div className="mt-6">
            <label className="mb-3 block text-xs font-semibold uppercase tracking-wide text-slate-500">
              Feedback
            </label>

            <textarea
              rows={5}
              value={feedback}
              maxLength={200}
              onChange={(e) => setFeedback(e.target.value)}
              placeholder="Enter detailed feedback here..."
              className="w-full rounded-lg border border-slate-300 p-3 outline-none focus:border-[#163D8F]"
            />

            <div className="mt-2 text-right text-xs text-slate-500">
              {feedback.length} / 200 words
            </div>
          </div>
        </div>

        {/* Footer */}
        <div className="flex justify-end gap-3 border-t px-6 py-4">
          <button
            onClick={onClose}
            className="rounded-lg px-4 py-2 text-sm font-medium text-slate-600 hover:bg-slate-100"
          >
            Cancel
          </button>

          <button
            onClick={handleSubmit}
            disabled={loading}
            className="rounded-lg bg-[#163D8F] px-5 py-2 text-sm font-medium text-white hover:bg-[#0F2E72] disabled:cursor-not-allowed disabled:opacity-50"
          >
            {editingCommentId ? "Update Feedback" : "Submit Feedback"}
          </button>
        </div>
      </div>
    </div>
  );
}
